<script setup lang="ts">
/** 麵包屑 */
export interface Breadcrumb {
  /** 名稱 */
  name: any
  /** 是否為當前頁面 */
  isActive?: boolean
  /** 連結 */
  link?: string
}

interface Props {
  data: Breadcrumb[]
}

withDefaults(defineProps<Props>(), {})

const localePath = useLocalePath()
</script>

<template>
  <!-- eslint-disable vue/no-v-text-v-html-on-component vue/no-v-html -->
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <nuxt-link :to="localePath('index')">
          {{ $t('breadcrumb_home') }}
        </nuxt-link>
      </li>
      <li
        v-for="(item, index) in data"
        :key="index"
        aria-current="page"
        class="breadcrumb-item"
        :class="{ active: item.isActive }"
      >
        <nuxt-link v-if="item.link" :to="localePath({ path: item.link })">
          {{ item.name }}
        </nuxt-link>
        <span v-else>{{ item.name }}</span>
      </li>
    </ol>
  </nav>
</template>
